// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604240804/js/" + chunkId + "." + {"44":"11c1845c","225":"636bfaef","481":"f7b021bf","486":"650987d9","770":"c3e971d1"}[chunkId] + ".0.9313277884080009.chunk.js";
};